import { useState, useEffect } from "react";
import Header from "./../components/Header";
import ContactInfo from "./../components/homeComponents/ContactInfo";
import CalltoActionSection from "./../components/homeComponents/CalltoActionSection";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import MobileNav from "../components/MobileNav";
import { Helmet } from "react-helmet";
import { Redirect, useLocation } from "react-router-dom";

import { HOME_PAGE_LISTING_SIZE } from "../config/Constant";

// import ClothingHomeScreen from "./ClothingHomeScreen";
// import FurnitureHomeScreen from "./FurnitureHomeScreen";
import GroceryHomeScreen from "./GroceryHomeScreen";
// import ElectronicHomeScreen from "./ElectronicHomeScreen";

// import ClothingProductScreen from "./ClothingProductScreen";
// import GroceryProductScreen from "./GroceryProductScreen";
// import FurnitureProductScreen from "./FurnitureProductScreen";
import GroceryFooter from "../components/GroceryFooter";
import LoginCoupon from "../shared/components/Modal/LoginCoupon";
// import ElectronicsProductScreen from "./ElectronicProductScreen"
// http://localhost:3000/furniture?brand=amul&sort=price_low_high&page=2&keyword=rice

const HomeScreen = ({ match }) => {
  const location = useLocation();

  const pageCategory = match.params.pageCategory || "grocery";
  const productId = match.params.id || null;

  /** ---------------------------
   * Query Params → Initial Filters
   ----------------------------*/
  const queryParams = new URLSearchParams(location.search);

  const initialFilters = {
    brand: queryParams.get("brand") || "",
    sort: queryParams.get("sort") || "latest",
    price: queryParams.get("price") || "",
    pageNumber: queryParams.get("page") || 1,
    pageSize: HOME_PAGE_LISTING_SIZE,
    keyword: queryParams.get("keyword") || "",
    searchId: queryParams.get("search_id") || "guest",
  };

  /** ---------------------------
   * Hooks MUST be here (top level)
   ----------------------------*/
  const [filters, setFilters] = useState(initialFilters);

  useEffect(() => {
    const query = new URLSearchParams(location.search);

    const storedSearchId =
      JSON.parse(localStorage.getItem("flashUser")) || null;
    console.log(storedSearchId);
    setFilters((prev) => ({
      ...prev,
      brand: query.get("brand") || "",
      sort: query.get("sort") || "latest",
      price: query.get("price") || "",
      pageNumber: query.get("page") || 1,
      keyword: query.get("keyword") || "",
      searchId: storedSearchId?.mobile || "guest",
    }));
  }, [location.search]);

  /** ---------------------------
   * NOW do conditional return
   ----------------------------*/
  // const validCategories = ["grocery", "furniture", "clothing", "electronics"];
  const validCategories = ["grocery"];
  if (!validCategories.includes(pageCategory)) {
    return <Redirect to="/grocery" />;
  }

  /** ---------------------------
   * Category Config
   ----------------------------*/
  const categoryConfig = {
    grocery: {
      title: "Buy Grocery Online",
      description: "Shop fresh groceries at best prices",
      screen: GroceryHomeScreen,
    },
    // furniture: {
    //   title: "Buy Furniture Online",
    //   description: "Explore modern furniture collections",
    //   screen: FurnitureHomeScreen,
    // },
    // clothing: {
    //   title: "Buy Clothing Online",
    //   description: "Discover trending fashion & clothing",
    //   screen: ClothingHomeScreen,
    // },
    // electronics: {
    //   title: "Buy Electronics Online",
    //   description: "Discover Smart Tech & AI Gadgets",
    //   screen: ElectronicHomeScreen,
    // },
  };

  // const productScreenConfig = {
  //   grocery: GroceryProductScreen,
  //   furniture: FurnitureProductScreen,
  //   clothing: ClothingProductScreen,
  // };

  const config = categoryConfig[pageCategory];
  // const isProductPage = Boolean(productId);

  // const SelectedScreen = isProductPage
  //   ? productScreenConfig[pageCategory]
  //   : config.screen;

  return (
    <div>
      <Helmet>
        <title>{config.title}</title>
        <meta name="description" content={config.description} />
      </Helmet>

      <LoginCoupon show={true} />

      {/* Header updates filters */}
      <Header
        onSearch={(kw) => {
          setFilters((prev) => ({
            ...prev,
            keyword: kw,
            pageNumber: 1,
          }));
        }}
      />

      <MobileNav />

      {/* <SelectedScreen match={match} filters={filters} productId={productId} /> */}
      <GroceryHomeScreen
        match={match}
        filters={filters}
        productId={productId}
      />

      <CalltoActionSection />
      <ContactInfo />
      <p className="att_heading_value">
        *Minimum Delivery Time is 1 Hrs, it depends. Any Order after 4 pm will
        be delivered next day. Cash on Delivery will be Done after call
        verfication.
      </p>
      <GroceryFooter />
    </div>
  );
};

export default HomeScreen;
